import request from '@/utils/request'

// 查询列表
export function apiMdmUomClassesList (query) {
  return request({
    url: '/mdm/mdmUomClasses/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiMdmUomClassesNewExport (data) {
  return request({
    url: '/mdm/mdmUomClasses/v2/export',
    method: 'post',
    data: data
  })
}

// 单位
export function apiMdmUomUnitsOfMeasureUnitOfMeasureList (query) {
  return request({
    url: '/mdm/mdmUomUnitsOfMeasure/unitOfMeasureList',
    method: 'get',
    params: query
  })
}

// 来源分类、基本单位
export function apiMdmUomConversionsUnitToData (query) {
  return request({
    url: '/mdm/mdmUomConversions/unitToData',
    method: 'get',
    params: query
  })
}

// 新增
export function apiMdmUomClassesAdd (data) {
  return request({
    url: '/mdm/mdmUomClasses',
    method: 'post',
    data: data
  })
}

// 修改
export function apiMdmUomClassesUpdate (data) {
  return request({
    url: '/mdm/mdmUomClasses',
    method: 'put',
    data: data
  })
}
